@if (visibleItems.length > 0) {
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      @if (brandPage != undefined) {
        <li class="breadcrumb-item">
          <a [routerLink]="brandPage.routerlink" [queryParams]="brandPage.queryParams">
            @if (settings?.useTextInseadOfIcon == true) {
              <span i18n="@@BreadcrumbHome">Home</span>
            }
            @if (settings?.useTextInseadOfIcon != true) {
              @if (settings?.iconClass == undefined) {
                <i class="bi bi-house"></i>
              }
              @if (settings?.iconClass != undefined) {
                <i class="bi" [class]="settings?.iconClass"></i>
              }
            }
          </a>
        </li>
      }

      @for (item of visibleItems; track item; let last = $last) {
        <li class="breadcrumb-item" [ngClass]="{ active: last, dropdown: item.siblings && item.siblings.length > 0 }">
          <span class="d-inline-flex align-items-center breadcrumb-content-wrapper">
            <a [routerLink]="last ? null : item.routerLink" [queryParams]="item.queryParams" [title]="item.text" class="breadcrumb-link">
              {{ item.text }}
            </a>

            @if (item.siblings && item.siblings.length > 0) {
              <a href="#" class="dropdown-toggle-icon ms-1" role="button" data-bs-toggle="dropdown" aria-expanded="false" (click)="$event.preventDefault()">
                <i class="bi bi-caret-down-fill" style="font-size: 0.8em"></i>
              </a>

              <ul class="dropdown-menu">
                @for (sibling of item.siblings; track sibling) {
                  <li>
                    <a class="dropdown-item" [routerLink]="[sibling.routerLink]" [queryParams]="sibling.queryParams">
                      {{ sibling.text }}
                    </a>
                  </li>
                }
              </ul>
            }
          </span>
        </li>
      }
    </ol>
  </nav>
}
